import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DropdownInput } from "../../../runQuote/components/DropdownInput";
import { TextInput } from "../../../runQuote/components/TextInput";

const PRIOR_LIMITS = [
  { value: "No Prior", label: "No Prior" },
  { value: "Less than 300k", label: "Less than 300k" },
  { value: "300k", label: "300k" },
  { value: "500k", label: "500k" },
];

const CLAIMS = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export function RentersHistory() {
  const { control, register } = useFormContext();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">History</h2>

      <TextInput
        register={register}
        label="Prior Renters insurance carrier (Put N/A if no prior)"
        id="priorCarrier"
        stepName="step3.priorCarrier"
        stepId="step3"
      />

      <DropdownInput
        control={control}
        label="Prior Renters Liability Limit"
        dropdownLabel="Select"
        stepName="step3.priorLiabilityLimit"
        stepId="step3"
        itemList={PRIOR_LIMITS}
      />

      <DropdownInput
        control={control}
        label="Reported claims excluding wind, hail, or lightning in the past 3 years"
        dropdownLabel="Select"
        stepName="step3.reportedClaims"
        stepId="step3"
        itemList={CLAIMS}
      />

      <div className="space-y-2">
        <p className="text-sm font-semibold text-red-600">
          ALL RENTERS POLICIES WITH WRITTEN BY COVER BADGER WILL BE E-SIGNATURE
        </p>
        <p className="text-sm font-semibold text-red-600">
          ALL RENTERS POLICIES WITH WRITTEN BY COVER BADGER WILL HAVE PAPERLESS BILLING VIA EMAIL
        </p>
      </div>
    </div>
  );
}
